import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { getDiscountRequestByStaff, getSSRByStaff } from "../../api/quotation.api";
import SSRTableRow from "./SSRTableRow";
import "./TasksStatus.scss";
import DiscountTableRow from "./DiscountTableRow";

const TasksStatus = () => {
  const [selectedTab, setSelectedTab] = useState<any>("discount-tab");
  const [loading, setLoading] = useState<any>(true);

  const [ssrData, setSSRData] = useState<any>([]);
  const [discountData, setDiscountData] = useState<any>([]);

  useEffect(() => {
    selectedTab === "discount-tab" ? getDiscount(): getTask();
  }, [selectedTab]);

  const getTask = async () => {
    setLoading(true);
    const data = await getSSRByStaff();
    if (data.status === 200) {
      setSSRData([...data?.result]);
    }
    setLoading(false);
  };
  
  const getDiscount = async () => {
    setLoading(true);
    const data = await getDiscountRequestByStaff();
    if (data.status === 200) {
      setDiscountData([...data?.result]);
    }
    setLoading(false);
  };

  return (
    <div className="relative h-full">
      <Row className="border mb-4 bg-white rounded m-h-[483px] w-100 m-0">
        <Col className="py-6 px-4 font-bold text-[22px]">
          <h4>Tasks</h4>
          <div className="flex gap-3 mt-3 mb-4 dash-nav">
            <div
              className={`cursor-pointer pb-0.5 ${selectedTab === "discount-tab" ? "active" : "text-muted"}`}
              onClick={() => setSelectedTab("discount-tab")}
            >
              Discount Requests
            </div>
            <div
              className={`cursor-pointer pb-0.5 ${selectedTab === "ssr-tab" ? "active" : "text-muted"}`}
              onClick={() => setSelectedTab("ssr-tab")}
            >
              SSR Requests
            </div>
          </div>
          {selectedTab === "ssr-tab" &&
            (!!ssrData.length ? (
              <>
                {ssrData?.map((item: any, index: number) => {
                  return <SSRTableRow item={item} index={index} ssrData={ssrData} setSSRData={setSSRData} />;
                })}
              </>
            ) : (
              <p className="text-center my-2 text-muted">{loading ? "Loading..." : "No SSR Requests Found"}</p>
            ))}
          {selectedTab === "discount-tab" &&
            (!!discountData.length ? (
              <>
                {discountData?.map((item: any, index: number) => {
                    return <DiscountTableRow item={item} index={index} discountData={discountData} setDiscountData={setDiscountData} />;
                })}
              </>
            ) : (
              <p className="text-center my-2 text-muted">{loading ? "Loading..." : "No Discount Requests Found"}</p>
            ))}
        </Col>
      </Row>
    </div>
  );
};

export default TasksStatus;
